import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import SpeakerSocialLinks from '../components/SpeakerSocialLinks';
import { SPONSOR_FORM_URL } from '../config';
import '../styles/DavidSinclairPage.css';

function DianaPalotasPage() {
  return (
    <>
      <Navbar />
      
      {/* Hero Section */}
      <section className="speaker-hero">
        <video 
          className="speaker-hero-video"
          autoPlay 
          muted 
          loop 
          playsInline
        >
          <source src="/assets/video-hero.webm" type="video/webm" />
        </video>
        <div className="speaker-hero-overlay"></div>
        
        <div className="container">
          <div className="speaker-hero-content">
            <div className="speaker-hero-left">
              <h1 className="speaker-hero-name">
                DIANA<br />PALOTAȘ
              </h1>
              <SpeakerSocialLinks speakerId="diana-palotas" className="speaker-hero-socials" linkClassName="speaker-hero-social-icon" />
              <Link to="https://my.brain-event.com" className="btn btn-primary btn-large btn-pulse speaker-hero-btn">
                CUMPĂRĂ UN TICKET
              </Link>
            </div>
            
            <div className="speaker-hero-right">
              <img 
                src="/assets/diana-palotas-transparent.png" 
                alt="Diana Palotas" 
                className="speaker-hero-image"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Who is Diana Palotas */}
      <section className="sinclair-intro">
        <div className="container">
          <div className="sinclair-intro-grid">
            <div className="sinclair-intro-content">
              <div className="sinclair-badge">DIANA PALOTAS</div>
              <h2 className="sinclair-intro-title">Cine este Diana Palotas?</h2>
              <p className="sinclair-intro-text">
                Diana Palotas este fondatorul și CEO-ul <strong>Neuros Europe</strong> și unul dintre specialiștii de referință din Europa în brain mapping, neuromodulare și fotobiomodulare.
              </p>
              <p className="sinclair-intro-text">
                Are <strong>peste 20 de ani experiență</strong> și a evaluat <strong>peste 100.000 de persoane</strong>, devenind o voce importantă în zona de neurotehnologie aplicată, cu focus pe rezultate reale, măsurabile.
              </p>
              <div className="sinclair-highlight-box">
                <p>Protagonistă în documentarul internațional <strong>„Longevity Revolution"</strong>, apărând alături de nume mari precum Bryan Johnson, Ray Kurzweil, George Church, Tony Robbins și Dr. George Shapiro.</p>
              </div>
            </div>
            <div className="sinclair-intro-image">
              <img 
                src="/assets/Diana-Palotas-card.webp" 
                alt="Diana Palotas"
                className="sinclair-portrait"
              />
              {/* Floating Stats Cards */}
              <div className="floating-stats-cards">
                <div className="floating-stat-card">
                  <div className="floating-stat-number">20+</div>
                  <div className="floating-stat-label">Ani experiență</div>
                </div>
                <div className="floating-stat-card">
                  <div className="floating-stat-number">100K+</div>
                  <div className="floating-stat-label">Persoane evaluate</div>
                </div>
                <div className="floating-stat-card">
                  <div className="floating-stat-number">6</div>
                  <div className="floating-stat-label">Clinici în România</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* What She Will Talk About */}
      <section className="benefits" id="despre-ce-va-vorbi">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Despre ce va vorbi</h2>
            <p className="section-subtitle">Teme centrale din prezentarea Dianei Palotas</p>
          </div>

          <div className="benefits-stories-grid">
            <div className="benefit-story-card" style={{backgroundImage: 'url(/assets/cum-citesti-mai-clar.png)'}}>
              <div className="story-badge">Claritate</div>
              <div className="story-content">
                <h3 className="story-title">Cum citești mai clar ce se întâmplă în creier</h3>
                <p className="story-description">Dincolo de „poveste" și simptome, înțelegi ce se întâmplă cu adevărat</p>
              </div>
            </div>

            <div className="benefit-story-card benefit-story-featured" style={{backgroundImage: 'url(/assets/de-ce-masurarea-activitatii.png)'}}>
              <div className="story-badge story-badge-featured">Măsurare</div>
              <div className="story-content">
                <h3 className="story-title">De ce măsurarea activității cerebrale aduce direcție</h3>
                <p className="story-description">Cum poate măsurarea activității cerebrale aduce direcție și siguranță în intervenție</p>
              </div>
            </div>

            <div className="benefit-story-card" style={{backgroundImage: 'url(/assets/brain-mapping-inclus-pentru-toti.webp)'}}>
              <div className="story-badge">Brain Mapping</div>
              <div className="story-content">
                <h3 className="story-title">Ce înseamnă un brain mapping făcut corect</h3>
                <p className="story-description">Ce poți înțelege dintr-un brain mapping făcut corect și ce informații oferă</p>
              </div>
            </div>

            <div className="benefit-story-card" style={{backgroundImage: 'url(/assets/plan-personal.webp)'}}>
              <div className="story-badge">Plan personalizat</div>
              <div className="story-content">
                <h3 className="story-title">Cum se leagă datele din qEEG de un plan personalizat</h3>
                <p className="story-description">Cum se conectează datele din qEEG cu un plan personalizat, aplicabil în practică</p>
              </div>
            </div>

            <div className="benefit-story-card" style={{backgroundImage: 'url(/assets/idei-practice-si-actionabile.png)'}}>
              <div className="story-badge">Tehnologii</div>
              <div className="story-content">
                <h3 className="story-title">Rolul tehnologiilor moderne în echilibrul mental</h3>
                <p className="story-description">Ce rol au neuromodularea și fotobiomodularea în echilibrul mental și performanță</p>
              </div>
            </div>
          </div>

          <div className="section-cta">
            <a href="https://my.brain-event.com" className="btn btn-primary btn-large">Cumpără un ticket</a>
          </div>
        </div>
      </section>

      {/* How It Helps You */}
      <section className="sinclair-benefits-you">
        <div className="container">
          <div className="section-header-centered">
            <h2 className="section-title">Cu ce te ajută pe tine</h2>
            <p className="section-subtitle">Beneficii concrete din prezentarea Dianei Palotas</p>
          </div>

          <div className="benefits-you-list">
            <div className="benefit-you-item">
              <div className="benefit-you-number">01</div>
              <div className="benefit-you-content">
                <h3 className="benefit-you-title">Ai mai multă claritate</h3>
                <p className="benefit-you-description">Înțelegi <strong>tipare reale, nu doar presupuneri</strong> despre funcționarea creierului</p>
              </div>
            </div>

            <div className="benefit-you-item">
              <div className="benefit-you-number">02</div>
              <div className="benefit-you-content">
                <h3 className="benefit-you-title">Iei decizii mai sigure</h3>
                <p className="benefit-you-description">Știi <strong>pe ce lucrezi și de ce</strong>, cu date concrete și măsurabile</p>
              </div>
            </div>

            <div className="benefit-you-item">
              <div className="benefit-you-number">03</div>
              <div className="benefit-you-content">
                <h3 className="benefit-you-title">Economisești timp</h3>
                <p className="benefit-you-description">Mergi <strong>mai direct către intervenția potrivită</strong>, fără încercări aleatorii</p>
              </div>
            </div>

            <div className="benefit-you-item">
              <div className="benefit-you-number">04</div>
              <div className="benefit-you-content">
                <h3 className="benefit-you-title">Crești calitatea rezultatelor</h3>
                <p className="benefit-you-description">Plan <strong>mai personalizat, progres mai ușor de urmărit</strong> și măsurabil</p>
              </div>
            </div>

            <div className="benefit-you-item featured">
              <div className="benefit-you-number">05</div>
              <div className="benefit-you-content">
                <h3 className="benefit-you-title">Vezi „harta" din spate</h3>
                <p className="benefit-you-description">Înțelegi cum se conectează <strong>creierul, emoțiile și comportamentul</strong> într-o imagine completă</p>
              </div>
            </div>
          </div>

          <div className="section-cta">
            <a href="https://my.brain-event.com" className="btn btn-primary btn-large btn-pulse">Rezervă-ți locul acum</a>
            <p className="cta-subtitle">Locuri limitate • Brain Event 2026</p>
          </div>
        </div>
      </section>

      {/* What She Does and Built */}
      <section className="sinclair-discoveries">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Ce face și ce a construit</h2>
            <p className="section-subtitle">Contribuții în neurotehnologie și dezvoltare clinică</p>
          </div>

          <div className="discoveries-grid">
            <div className="discovery-card">
              <div className="discovery-icon">
                <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M24 8 L32 20 L28 20 L28 28 L36 28 L36 32 L28 32 L28 40 L20 40 L20 32 L12 32 L12 28 L20 28 L20 20 L16 20 L24 8Z" fill="currentColor" opacity="0.3"/>
                  <circle cx="24" cy="24" r="4" fill="currentColor"/>
                  <circle cx="34" cy="18" r="3" fill="currentColor"/>
                  <circle cx="14" cy="18" r="3" fill="currentColor"/>
                  <circle cx="34" cy="34" r="3" fill="currentColor"/>
                  <circle cx="14" cy="34" r="3" fill="currentColor"/>
                </svg>
              </div>
              <h3 className="discovery-title">Tehnologia iMediSync</h3>
              <p className="discovery-description">A adus în Europa una dintre cele mai avansate soluții pentru analiză și neuromodulare a activității cerebrale</p>
            </div>

            <div className="discovery-card featured">
              <div className="discovery-icon">
                <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="24" cy="24" r="12" stroke="currentColor" strokeWidth="2" fill="none" opacity="0.3"/>
                  <circle cx="24" cy="24" r="8" stroke="currentColor" strokeWidth="2" fill="none" opacity="0.5"/>
                  <circle cx="24" cy="24" r="4" stroke="currentColor" strokeWidth="2" fill="none"/>
                  <circle cx="24" cy="24" r="2" fill="currentColor"/>
                </svg>
              </div>
              <h3 className="discovery-title">Rețea europeană</h3>
              <p className="discovery-description">A construit o rețea europeană de specialiști și a susținut dezvoltarea de programe clinice în mai multe arii</p>
            </div>

            <div className="discovery-card">
              <div className="discovery-icon">
                <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M8 24 Q 16 12, 24 24 T 40 24" stroke="currentColor" strokeWidth="2.5" fill="none"/>
                  <path d="M10 28 Q 18 16, 26 28 T 42 28" stroke="currentColor" strokeWidth="2.5" fill="none" opacity="0.5"/>
                  <circle cx="24" cy="24" r="3" fill="currentColor"/>
                  <circle cx="12" cy="20" r="2" fill="currentColor"/>
                  <circle cx="36" cy="20" r="2" fill="currentColor"/>
                </svg>
              </div>
              <h3 className="discovery-title">6 clinici în România</h3>
              <p className="discovery-description">Coordonare a unei rețele de 6 clinici care lucrează într-o abordare modernă, interdisciplinară</p>
            </div>

            <div className="discovery-card">
              <div className="discovery-icon">
                <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="24" cy="24" r="10" stroke="currentColor" strokeWidth="2" fill="none"/>
                  <path d="M16 8 L24 16 L32 8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M16 40 L24 32 L32 40" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <h3 className="discovery-title">Programe clinice</h3>
              <p className="discovery-description">Dezvoltare de programe clinice dedicate în multiple domenii de specializare</p>
            </div>
          </div>
        </div>
      </section>

      {/* Areas of Contribution */}
      <section className="sinclair-stats">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Direcțiile în care a contribuit direct</h2>
            <p className="section-subtitle">Domenii de expertiză și impact</p>
          </div>

          <div className="stats-hero-grid">
            <div className="stat-hero-card">
              <div className="stat-number">Psihologie</div>
              <div className="stat-label">Aplicare neurotehnologie în psihologie</div>
            </div>

            <div className="stat-hero-card featured">
              <div className="stat-number">Neuromodulare</div>
              <div className="stat-label">Neuromodulare și optimizare cerebrală</div>
            </div>

            <div className="stat-hero-card">
              <div className="stat-number">Medicină alternativă</div>
              <div className="stat-label">Integrare tehnologie modernă</div>
            </div>

            <div className="stat-hero-card">
              <div className="stat-number">Nutriție</div>
              <div className="stat-label">Corelare cu funcționarea cerebrală</div>
            </div>

            <div className="stat-hero-card">
              <div className="stat-number">Fotobiomodulare</div>
              <div className="stat-label">Tehnologie avansată de stimulare</div>
            </div>

            <div className="stat-hero-card">
              <div className="stat-number">Brain Mapping</div>
              <div className="stat-label">Analiză avansată a activității cerebrale</div>
            </div>
          </div>
        </div>
      </section>

      {/* International Experience - HIDDEN TEMPORARILY */}
      {/* 
      <section className="sinclair-media-new">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Experiență internațională</h2>
            <p className="section-subtitle">Traininguri și formare în peste 30 de țări</p>
          </div>

          <div className="media-two-column-grid">
            <div className="media-two-column-card">
              <div className="media-two-column-content">
                <div className="media-badge-small">Formare</div>
                <h3 className="media-two-column-title">Traininguri internaționale</h3>
                <p className="media-two-column-description">
                  Diana predă și susține traininguri în <strong>peste 30 de țări</strong>, formând specialiști în interpretarea qEEG, neuromodularea cerebrală și utilizarea tehnologiei iMediSync.
                </p>
                <ul className="media-highlights-list">
                  <li>Interpretarea qEEG</li>
                  <li>Neuromodularea cerebrală</li>
                  <li>Utilizarea tehnologiei iMediSync</li>
                </ul>
              </div>
              <div className="media-two-column-image">
                <img src="/assets/events-david-sinclair.jpg" alt="Diana Palotas - Traininguri internaționale" />
              </div>
            </div>

            <div className="media-two-column-card featured">
              <div className="media-two-column-image">
                <img src="/assets/publicatii.png" alt="Diana Palotas - Programe dedicate" />
              </div>
              <div className="media-two-column-content">
                <div className="media-badge-featured">Impact</div>
                <h3 className="media-two-column-title">Peste 1.000 de cursanți</h3>
                <p className="media-two-column-description">
                  A dezvoltat programe dedicate pentru <strong>peste 1.000 de cursanți</strong> și a colaborat cu experți internaționali de top în domeniul neurotehnologiei.
                </p>
                <div className="media-stats">
                  <div className="media-stat-item">
                    <span className="media-stat-number">30+</span>
                    <span className="media-stat-label">Țări</span>
                  </div>
                  <div className="media-stat-item">
                    <span className="media-stat-number">1.000+</span>
                    <span className="media-stat-label">Cursanți formați</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      */}

      {/* Speakers Section */}
      <section className="benefits" id="speakeri">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Alți Speakeri de la Brain Event 2026</h2>
            <p className="section-subtitle">Experți de top din domeniul neuroștiinței și optimizării cognitive</p>
          </div>

          <div className="benefits-stories-grid">
            {/* David Sinclair */}
            <Link to="/david-sinclair" className="benefit-story-card" style={{backgroundImage: 'url(/david-sinclair-headshot-2024.png)'}}>
              <div className="story-badge">Speaker</div>
              <div className="story-content">
                <h3 className="story-title">David Sinclair</h3>
                <p className="story-description">Profesor Harvard • Expert în Longevitate</p>
                {/* <SpeakerSocialLinks speakerId="david-sinclair" className="benefit-story-socials" linkClassName="benefit-story-social-icon" stopPropagation /> */}
              </div>
            </Link>

            {/* Dr. Daniel Amen */}
            <Link to="/daniel-amen" className="benefit-story-card" style={{backgroundImage: 'url(/assets/amen-speaker.webp)'}}>
              <div className="story-badge">Speaker</div>
              <div className="story-content">
                <h3 className="story-title">Dr. Daniel Amen</h3>
                <p className="story-description">Medic în Sănătatea Creierului • Prezență Online</p>
                {/* <SpeakerSocialLinks speakerId="daniel-amen" className="benefit-story-socials" linkClassName="benefit-story-social-icon" stopPropagation /> */}
              </div>
            </Link>

            {/* Niculina Gheorghiță */}
            <Link to="/niculina-gheorghita" className="benefit-story-card" style={{backgroundImage: 'url(/assets/niculina-psiholog.webp)'}}>
              <div className="story-badge">Speaker</div>
              <div className="story-content">
                <h3 className="story-title">Niculina Gheorghiță</h3>
                <p className="story-description">Psiholog • Autor • Trainer</p>
              </div>
            </Link>

            {/* Matthew Walker - Featured */}
            <Link to="/matthew-walker" className="benefit-story-card benefit-story-featured" style={{backgroundImage: 'url(/assets/matthew-walker-speaker.webp)'}}>
              <div className="story-badge story-badge-featured">Speaker</div>
              <div className="story-content">
                <h3 className="story-title">Matthew Walker</h3>
                <p className="story-description">Expert în Somnologie • Autor Bestseller</p>
              </div>
            </Link>

            {/* Specialist Neurofiziologie */}
            <div className="benefit-story-card" style={{backgroundImage: 'url(/mysterious-speaker-new.png)'}}>
              <div className="story-badge">VA FI ANUNȚAT</div>
              <div className="story-content">
                <h3 className="story-title">Specialist Neurofiziologie</h3>
                <p className="story-description">A definit standardele moderne ale neruofiziologiei</p>
              </div>
            </div>

            {/* Expert Neuromodulare */}
            <div className="benefit-story-card" style={{backgroundImage: 'url(/mysterious-speaker-new.png)'}}>
              <div className="story-badge">VA FI ANUNȚAT</div>
              <div className="story-content">
                <h3 className="story-title">Expert Neuromodulare</h3>
                <p className="story-description">A optimizat recuperarea sistemului nervos</p>
              </div>
            </div>

            {/* Psiholog si Formator */}
            <div className="benefit-story-card" style={{backgroundImage: 'url(/mysterious-speaker-new.png)'}}>
              <div className="story-badge">VA FI ANUNȚAT</div>
              <div className="story-content">
                <h3 className="story-title">Psiholog si Formator</h3>
                <p className="story-description">Trei Decenii in practica psihologica</p>
              </div>
            </div>
          </div>

          <div className="section-cta">
            <a href="https://my.brain-event.com" className="btn btn-primary btn-large">Cumpara un ticket</a>
          </div>
        </div>
      </section>

      {/* Contact / Sponsor form — now on dedicated sponsorship app */}
      <section className="speaker-contact">
        <div className="container">
          <div className="speaker-contact-header">
            <h2 className="speaker-contact-title">Ai întrebări despre Diana Palotas sau Brain Event?</h2>
            <p className="speaker-contact-subtitle">
              Completează formularul de sponsorizare și echipa noastră te va contacta în cel mai scurt timp.
            </p>
          </div>
          <div style={{ textAlign: 'center' }}>
            <a href={SPONSOR_FORM_URL} className="btn btn-primary btn-large">Aplică pentru Sponsorizare</a>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}

export default DianaPalotasPage;







